import { render, staticRenderFns } from "./JSONTemplateDataEditField.vue?vue&type=template&id=0a6e55c1&scoped=true"
import script from "./JSONTemplateDataEditField.vue?vue&type=script&lang=js"
export * from "./JSONTemplateDataEditField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6e55c1",
  null
  
)

export default component.exports